module.exports = __webpack_public_path__ + "img/微信公众号-UA官方账号二维码-s.b92d919.png";